/* Aximyra accordion groups: one open per group; auto-close when 25% or less visible. */
(function(){
  function initAccordions(){
    document.querySelectorAll('[data-axm-accordions]').forEach(function(root){
      if(root.dataset.axmAccordionReady==='true')return;
      var items=Array.from(root.querySelectorAll('[data-axm-acc-item]'));
      if(items.length<2)return;
      root.dataset.axmAccordionReady='true';
      function closeAll(){
        items.forEach(function(item){if(item.open)item.open=false});
      }
      closeAll();
      items.forEach(function(item){
        item.addEventListener('toggle',function(){
          if(!item.open)return;
          items.forEach(function(other){if(other!==item&&other.open)other.open=false});
        });
      });
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.intersectionRatio<=0.25)closeAll();
          });
        },{threshold:[0,0.25,0.26,0.5,1]});
        observer.observe(root);
      }else{
        // Fallback for older browsers: compute the visible fraction on scroll.
        var queued=false;
        function checkVisibility(){
          queued=false;
          var rect=root.getBoundingClientRect();
          var visible=Math.max(0,Math.min(rect.bottom,window.innerHeight)-Math.max(rect.top,0));
          var ratio=visible/Math.max(rect.height,1);
          if(ratio<=0.25)closeAll();
        }
        window.addEventListener('scroll',function(){
          if(queued)return;
          queued=true;
          window.requestAnimationFrame(checkVisibility);
        },{passive:true});
        window.addEventListener('resize',checkVisibility);
        checkVisibility();
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAccordions);
  else initAccordions();
  document.addEventListener('shopify:section:load',initAccordions);
})();